@file:Suppress("MagicNumber", "ForbiddenComment", "UnusedPrivateProperty", "LongParameterList")

package floris.graphics.core.styles

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.materialdesignsystem.theme.darkColorScheme
import com.materialdesignsystem.theme.lightColorScheme

private val PrimaryLight = Color.rgb(103, 80, 164)
private val OnPrimaryLight = Color.rgb(255, 255, 255)
private val PrimaryContainerLight = Color.rgb(234, 221, 255)
private val OnPrimaryContainerLight = Color.rgb(33, 0, 93)
private val SecondaryLight = Color.rgb(98, 91, 113)
private val OnSecondaryLight = Color.rgb(255, 255, 255)
private val SecondaryContainerLight = Color.rgb(232, 222, 248)
private val OnSecondaryContainerLight = Color.rgb(29, 25, 43)
private val TertiaryLight = Color.rgb(125, 82, 96)
private val OnTertiaryLight = Color.rgb(255, 255, 255)
private val TertiaryContainerLight = Color.rgb(255, 216, 228)
private val OnTertiaryContainerLight = Color.rgb(49, 17, 29)
private val ErrorLight = Color.rgb(179, 38, 30)
private val OnErrorLight = Color.rgb(255, 255, 255)
private val ErrorContainerLight = Color.rgb(249, 222, 220)
private val OnErrorContainerLight = Color.rgb(65, 14, 11)
private val OutlineLight = Color.rgb(121, 116, 126)
private val BackgroundLight = Color.rgb(255, 251, 254)
private val OnBackgroundLight = Color.rgb(28, 27, 31)
private val SurfaceLight = Color.rgb(255, 251, 254)
private val OnSurfaceLight = Color.rgb(28, 27, 31)
private val SurfaceVariantLight = Color.rgb(231, 224, 236)
private val OnSurfaceVariantLight = Color.rgb(73, 69, 79)
private val InverseSurfaceLight = Color.rgb(49, 48, 51)
private val OnInverseSurfaceLight = Color.rgb(244, 239, 244)
private val InversePrimaryLight = Color.rgb(208, 188, 255)
private val ShadowLight = Color.rgb(0, 0, 0)
private val SurfaceTintLight = Color.rgb(103, 80, 164)
private val OutlineVariantLight = Color.rgb(202, 196, 208)
private val ScrimLight = Color.rgb(0, 0, 0)
//    private val GrayLight = Color.rgb(r = 207, g = 207, b = 207)
//    private val LightGrayLight = Color.rgb(r = 237, g = 237, b = 237)
//    private val LighterGrayLight = Color.rgb(r = 249, g = 249, b = 249)

private val PrimaryDark = Color.rgb(208, 188, 255)
private val OnPrimaryDark = Color.rgb(56, 30, 114)
private val PrimaryContainerDark = Color.rgb(79, 55, 139)
private val OnPrimaryContainerDark = Color.rgb(234, 221, 255)
private val SecondaryDark = Color.rgb(204, 194, 220)
private val OnSecondaryDark = Color.rgb(51, 45, 65)
private val SecondaryContainerDark = Color.rgb(74, 68, 88)
private val OnSecondaryContainerDark = Color.rgb(232, 222, 248)
private val TertiaryDark = Color.rgb(239, 184, 200)
private val OnTertiaryDark = Color.rgb(73, 37, 50)
private val TertiaryContainerDark = Color.rgb(99, 59, 72)
private val OnTertiaryContainerDark = Color.rgb(255, 216, 228)
private val ErrorDark = Color.rgb(242, 184, 181)
private val OnErrorDark = Color.rgb(96, 20, 16)
private val ErrorContainerDark = Color.rgb(140, 29, 24)
private val OnErrorContainerDark = Color.rgb(249, 222, 220)
private val OutlineDark = Color.rgb(147, 143, 153)
private val BackgroundDark = Color.rgb(28, 27, 31)
private val OnBackgroundDark = Color.rgb(230, 225, 229)
private val SurfaceDark = Color.rgb(28, 27, 31)
private val OnSurfaceDark = Color.rgb(230, 225, 229)
private val SurfaceVariantDark = Color.rgb(73, 69, 79)
private val OnSurfaceVariantDark = Color.rgb(202, 196, 208)
private val InverseSurfaceDark = Color.rgb(230, 225, 229)
private val OnInverseSurfaceDark = Color.rgb(49, 48, 51)
private val InversePrimaryDark = Color.rgb(103, 80, 164)
private val ShadowDark = Color.rgb(0, 0, 0)
private val SurfaceTintDark = Color.rgb(255, 208, 188)
private val OutlineVariantDark = Color.rgb(73, 69, 79)
private val ScrimDark = Color.rgb(0, 0, 0)

val FgLightColorScheme = lightColorScheme(
    primary = PrimaryLight,
    onPrimary = OnPrimaryLight,
    primaryContainer = PrimaryContainerLight,
    onPrimaryContainer = OnPrimaryContainerLight,
    inversePrimary = InversePrimaryLight,
    secondary = SecondaryLight,
    onSecondary = OnSecondaryLight,
    secondaryContainer = SecondaryContainerLight,
    onSecondaryContainer = OnSecondaryContainerLight,
    tertiary = TertiaryLight,
    onTertiary = OnTertiaryLight,
    tertiaryContainer = TertiaryContainerLight,
    onTertiaryContainer = OnTertiaryContainerLight,
    background = BackgroundLight,
    onBackground = OnBackgroundLight,
    surface = SurfaceLight,
    onSurface = OnSurfaceLight,
    surfaceVariant = SurfaceVariantLight,
    onSurfaceVariant = OnSurfaceVariantLight,
    surfaceTint = SurfaceTintLight,
    inverseSurface = InverseSurfaceLight,
    inverseOnSurface = OnInverseSurfaceLight,
    error = ErrorLight,
    onError = OnErrorLight,
    errorContainer = ErrorContainerLight,
    onErrorContainer = OnErrorContainerLight,
    outline = OutlineLight,
    outlineVariant = OutlineVariantLight,
    scrim = ScrimLight,
    surfaceBright = SurfaceLight,
    surfaceDim = SurfaceLight,
    surfaceContainer = SurfaceLight,
    surfaceContainerHigh = SurfaceLight,
    surfaceContainerHighest = SurfaceLight,
    surfaceContainerLow = SurfaceLight,
    surfaceContainerLowest = SurfaceLight,
)

val FgDarkColorScheme = darkColorScheme(
    primary = PrimaryDark,
    onPrimary = OnPrimaryDark,
    primaryContainer = PrimaryContainerDark,
    onPrimaryContainer = OnPrimaryContainerDark,
    inversePrimary = InversePrimaryDark,
    secondary = SecondaryDark,
    onSecondary = OnSecondaryDark,
    secondaryContainer = SecondaryContainerDark,
    onSecondaryContainer = OnSecondaryContainerDark,
    tertiary = TertiaryDark,
    onTertiary = OnTertiaryDark,
    tertiaryContainer = TertiaryContainerDark,
    onTertiaryContainer = OnTertiaryContainerDark,
    background = BackgroundDark,
    onBackground = OnBackgroundDark,
    surface = SurfaceDark,
    onSurface = OnSurfaceDark,
    surfaceVariant = SurfaceVariantDark,
    onSurfaceVariant = OnSurfaceVariantDark,
    surfaceTint = SurfaceTintDark,
    inverseSurface = InverseSurfaceDark,
    inverseOnSurface = OnInverseSurfaceDark,
    error = ErrorDark,
    onError = OnErrorDark,
    errorContainer = ErrorContainerDark,
    onErrorContainer = OnErrorContainerDark,
    outline = OutlineDark,
    outlineVariant = OutlineVariantDark,
    scrim = ScrimDark,
    surfaceBright = SurfaceDark,
    surfaceDim = SurfaceDark,
    surfaceContainer = SurfaceDark,
    surfaceContainerHigh = SurfaceDark,
    surfaceContainerHighest = SurfaceDark,
    surfaceContainerLow = SurfaceDark,
    surfaceContainerLowest = SurfaceDark,
)
